import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { ASSOCIATED_INVESTORS_PAGE_TITLE } from 'constants/associated-investors';
import { DashboardLayout } from 'page-components';
import AssociatedInvesorsTable from 'page-components/associated-investors/AssociatedInvestorsTable';
import { TitleWithDescription } from 'shared-components';

const AssociatedInvestors = () => {
  const { fund } = useParams();

  const fundName = useMemo(() => {
    if (!fund) return '';

    const unslugged = decodeURIComponent(fund).replace(/-/g, ' ');

    return unslugged.replace(/\b\w/g, (c) => c.toUpperCase());
  }, [fund]);

  return (
    <DashboardLayout>
      <div className='contentful-dashboard-page'>
        <TitleWithDescription
          className='mb-6'
          title={ASSOCIATED_INVESTORS_PAGE_TITLE}
          description={`Fund: ${fundName}`}
        />
        <AssociatedInvesorsTable />
      </div>
    </DashboardLayout>
  );
};

export default AssociatedInvestors;
